import GestaoEmailsAutomaticosPage from './pages/GestaoEmailsAutomaticosPage.vue'
import CriarEmailAutomaticoPage from './pages/CriarEmailAutomaticoPage.vue'
import ConfiguracaoEmailAutomaticoPage from './pages/ConfiguracaoEmailAutomaticoPage.vue'

const routes = [
  {
    path: 'gestao-emails-automaticos',
    name: 'gestao-emails-automaticos',
    component: GestaoEmailsAutomaticosPage
  },
  {
    path: 'gestao-emails-automaticos/novo',
    name: 'gestao-emails-automaticos-criar',
    component: CriarEmailAutomaticoPage
  },
  {
    path: 'gestao-emails-automaticos/:id',
    name: 'gestao-emails-automaticos-editar',
    component: ConfiguracaoEmailAutomaticoPage,
    props: true
  }
]

export default routes
